import React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useApolloClient } from '@apollo/client';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { BILLING_CONTACT_PATH, pathToRoute } from '../../constants/routes';
import { BILLING_PAGE_QUERY } from '../../billing';
import { useHybridAuthToken } from '../../components/hybridAuthToken';

export const AutopayConfirmationModal = ({ paymentMethod, lastFour }) => {
  const { prospectId, contactId } = useParams();
  const history = useHistory();
  const hybridAuthToken = useHybridAuthToken();
  const client = useApolloClient();

  const closeModal = async (event, reason) => {
    if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
      event.preventDefault();
      return;
    }

    if (hybridAuthToken) {
      await client.query({
        query: BILLING_PAGE_QUERY,
        variables: {
          prospectId,
          contactId,
          hybridAuthToken,
        },
        fetchPolicy: 'network-only',
      });
    }

    history.replace(pathToRoute(BILLING_CONTACT_PATH, { prospectId, contactId }));
  };

  return (
    <Dialog
      open={true}
      onClose={closeModal}
      aria-labelledby="form-dialog-title"
      data-testid="autopay-confirmation-modal"
    >
      <>
        <DialogTitle id="form-dialog-title">Autopay Confirmed</DialogTitle>
        <DialogContent>
          <DialogContentText color="textPrimary">
            {`Enrolled with ${paymentMethod}${lastFour ? ` ending in ${lastFour}` : ''}`}
          </DialogContentText>
        </DialogContent>
      </>
      <DialogActions>
        <Button onClick={closeModal} color="primary">
          Done
        </Button>
      </DialogActions>
    </Dialog>
  );
};

AutopayConfirmationModal.propTypes = {
  paymentMethod: PropTypes.string.isRequired,
  lastFour: PropTypes.string,
};
